<template>
  <div class="base-register">
    <UiBadge
      class="base-register__badge"
      type="secondary"
      background="solid"
      size="small"
      text="+ Бонус"
      icon-right="common/gift-filled"
    />

    <UiBtn
      class="base-register__button"
      color="primary"
      :text="$t('registration')"
      @click="openLoginModal"
    />
  </div>
</template>

<script>

export default {
  name: 'BaseRegister',
  methods: {
    openLoginModal() {
      this.$newModal.openAuthOrRegister()
    },
  },
}
</script>

<style lang="scss" scoped>
.base-register {
  position: relative;

  &__badge {
    position: absolute;
    z-index: 1;
    top: 0;
    right: 12px;
    transform: translateY(-50%);
  }

  &__button {
    width: 100%;
  }
}
</style>
